const TOAST_GETTERS = {
  visible: 'toast/visible',
  type: 'toast/type',
  title: 'toast/title',
  message: 'toast/message',
}

const TOAST_DISPATCHERS = {
  setSuccessMessage: 'toast/setSuccessMessage',
  setErrorMessage: 'toast/setErrorMessage',
  resetStore: 'toast/resetStore',
}

export { TOAST_GETTERS, TOAST_DISPATCHERS }
